import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface AcknowledgeUserIdentityConflictsParams {
    ids: string[];
}

export class AcknowledgeUserIdentityConflictsRequest extends Request<AcknowledgeUserIdentityConflictsParams, IResult> {
  constructor(params: AcknowledgeUserIdentityConflictsParams) {
    super('acknowledgeUserIdentityConflicts', params);
  }
}
